import { writable } from 'svelte/store';

export type HabitCategoryHeaderStyle = 'normal' | 'compact';

export type HabitsViewSettings = {
  showStatusIcons: boolean;
  useCategoryColor: boolean;
  categoryHeaderStyle: HabitCategoryHeaderStyle;
};

export const DEFAULT_HABITS_VIEW_SETTINGS: HabitsViewSettings = {
  showStatusIcons: true,
  useCategoryColor: true,
  categoryHeaderStyle: 'normal',
};

export const DEFAULT_COMPLETED_CELL_COLOR = '#4f9b6d';
export const HABITS_VIEW_SETTINGS_KEY = 'habits:viewSettings';

export function normalizeHabitsViewSettings(value: unknown): HabitsViewSettings {
  const raw = value && typeof value === 'object' ? (value as Partial<HabitsViewSettings>) : {};
  return {
    showStatusIcons: raw.showStatusIcons !== false,
    useCategoryColor: raw.useCategoryColor !== false,
    categoryHeaderStyle: raw.categoryHeaderStyle === 'compact' ? 'compact' : 'normal',
  };
}

function readHabitsViewSettings(): HabitsViewSettings {
  if (typeof localStorage === 'undefined') return { ...DEFAULT_HABITS_VIEW_SETTINGS };
  const raw = localStorage.getItem(HABITS_VIEW_SETTINGS_KEY);
  if (raw === null) return { ...DEFAULT_HABITS_VIEW_SETTINGS };
  try {
    return normalizeHabitsViewSettings(JSON.parse(raw));
  } catch {
    return { ...DEFAULT_HABITS_VIEW_SETTINGS };
  }
}

export const habitsViewSettings = writable<HabitsViewSettings>(readHabitsViewSettings());

habitsViewSettings.subscribe((value) => {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(
    HABITS_VIEW_SETTINGS_KEY,
    JSON.stringify(normalizeHabitsViewSettings(value)),
  );
});

export function updateHabitsViewSettings(patch: Partial<HabitsViewSettings>) {
  habitsViewSettings.update((current) => normalizeHabitsViewSettings({ ...current, ...patch }));
}
